import { Injectable } from '@angular/core';
import { PComparatorProductsRequest, PComparatorStatusRequest } from './product-comparator.model';
import { catchError, map, Observable } from 'rxjs';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { failStatus, successStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class ProductComparatorAdapter {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private translationService: TranslationService,
  ) {}

  getPComparator(config: PComparatorProductsRequest): Observable<PComparatorStatusRequest> {
    const queryParams = {
      products: config.pids || config.pid,
      useProductReferences: config.useProductReferences || false,
    };

    const url = this.occEndPointService.buildUrl('productComparator', { queryParams });

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          ...{
            pComparator: {
              products: response.products || [],
              sections: response.sections || [],
            },
          },
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
            // ...successStatus,
            // pComparator: {
            //   products: productComparatorRequestPID.pComparator!.products,
            //   sections: productComparatorRequestPID.pComparator!.sections,
            // },
          })),
        );
      }),
    );
  }
}
